$('.header-slideshow').each(function() {
  var $slideshow = $(this);
  var $slides = $(".header-slideshow__slide",$slideshow);
  var index = 0;
  var count = $slides.length;
  $slides.first().addClass('header-slideshow__slide--active');
  setInterval(function() {
    $slides.eq(index).removeClass('header-slideshow__slide--active');
    index = (index + 1) % count;
    $slides.eq(index).addClass('header-slideshow__slide--active');
  }, $slideshow.data('speed'));
});
